import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : config dashboard panels
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { isString } from 'ldash';
import log from 'uix/logging';
import { DashSegment } from 'uix/components/grid';
// ---Local imports
import { DomainConfigTable, ConfigMenu } from './components';
// ---Exports
const DomainConfigPanel = ({ section, header = 'Konfiguration', i18n })=>{
    if (isString(section)) {
        section = [
            section
        ];
    }
    return /*#__PURE__*/ _jsx(DashSegment, {
        header: header,
        menu: /*#__PURE__*/ _jsx(ConfigMenu, {
            basic: true
        }),
        children: section.map((sec, i)=>/*#__PURE__*/ _jsx(DomainConfigTable, {
                basic: true,
                section: sec
            }, sec))
    });
};
export const DashDomainConfig = {
    Comp: DomainConfigPanel,
    datatypes: [
        'domain'
    ]
};
